// src/app/utilities/statusColors.ts
// Utility functions for consistent status color handling across components

export const statusColorUtilities = {
  /**
   * Get color for general status values (active/inactive, etc.)
   */
  getStatusColor: (status: any): string => {
    switch (status) {
      case 1:
      case 'active':
      case 'Active':
        return '#28a745' // green
      case 0:
      case 'inactive':
      case 'Inactive':
        return '#dc3545' // red
      case 'pending':
      case 'Pending':
        return '#ffc107' // yellow
      case 'Male':
        return '#007bff' // blue
      case 'Female':
        return '#e83e8c' // pink
      case 'High':
        return '#dc3545' // red
      case 'Medium':
        return '#ffc107' // yellow
      case 'Low':
        return '#28a745' // green
      default:
        return '#6c757d' // gray
    }
  },

  /**
   * Get color for request status values (approved/pending/rejected)
   */
  getRequestedStatusColor: (status: any): string => {
    switch (status) {
      case 'approved':
      case 'Approved':
      case 1:
        return '#28a745' // green
      case 'pending':
      case 'Pending':
      case 0:
        return '#ffc107' // yellow
      case 'rejected':
      case 'Rejected':
      case -1:
        return '#dc3545' // red
      default:
        return '#6c757d' // gray
    }
  },

  /**
   * Get color for blood pressure severity categories
   */
  getSeverityColor: (severity: any): string => {
    switch (severity?.toString().toLowerCase()) {
      case '1':
      return '#81D4FA'
    case '2':
      return 'green'
    case '3':
      return '#eeca00'
    case '4':
      return '#FF9800'
    case '5':
      return '#F44336'
    case '6':
      return '#B71C1C'
    default:
      return 'blue'
    }
  }
}

// Export individual functions for convenience
export const { getStatusColor, getRequestedStatusColor, getSeverityColor } = statusColorUtilities
